// UNREGISTER Service Worker to fix aggressive caching issues
// This ensures users always get the latest version without needing hard refresh
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Unregister ALL service workers
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then((success) => {
          if (success) {
            console.log('✅ Service Worker unregistered successfully');
          }
        });
      });
    });

    // Clear all caches
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
          console.log('🗑️ Cache deleted:', cacheName);
        });
      });
    }
  });
}

// Listen for install prompt (PWA can still be installed without SW)
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('💾 PWA install prompt available');
  e.preventDefault();
  deferredPrompt = e;
});

window.addEventListener('appinstalled', () => {
  console.log('✅ PWA installed successfully');
  deferredPrompt = null;
});
